var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.loaderDimmer},[_c('i',{staticClass:"icon el-icon-loading",staticStyle:{"color":"var(--gray-text)","font-size":"36px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }